export enum AuthTokenType {
  AccessToken,
  RefreshToken,
  IsAC
}
